module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-10.68141586.svg";